import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const [planos, setPlanos] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [indiceNotificacao, setIndiceNotificacao] = useState(0);
  const [fadeAtivo, setFadeAtivo] = useState(false);
  const [notificacoesPix, setNotificacoesPix] = useState([]);

  // 1. Carregar Planos
  useEffect(() => {
    const carregarPlanos = async () => {
      try {
        const response = await api.get('/public/planos');
        setPlanos(response.data);
      } catch (error) {
        console.error("Erro ao carregar planos do QuitaGo:", error);
      } finally {
        setLoading(false);
      }
    };
    carregarPlanos();
  }, []);

  // 2. Carregar Notificações do PIX
  useEffect(() => {
    const carregarNotificacoesPix = async () => {
      try {
        const response = await api.get('/public/notificacoes/pix');
        setNotificacoesPix(response.data);
      } catch (error) {
        console.error('Erro ao carregar notificações PIX:', error);
      }
    };
    carregarNotificacoesPix();
  }, []);

  // 3. Controle do Carrossel (Corrigido)
  useEffect(() => {
    // Retorna imediatamente se o array estiver vazio, evitando NaN no cálculo
    if (notificacoesPix.length === 0) return;

    const intervalo = setInterval(() => {
      setFadeAtivo(true); 
      
      setTimeout(() => {
        setIndiceNotificacao((prev) => (prev + 1) % notificacoesPix.length);
        setFadeAtivo(false); 
      }, 300);

    }, 3500);

    // Limpa o intervalo ao desmontar ou se o tamanho do array mudar
    return () => clearInterval(intervalo);
  }, [notificacoesPix.length]); // Adicionada a dependência correta

  const notificacaoAtual = notificacoesPix.length > 0
    ? notificacoesPix[indiceNotificacao]
    : null;
    
  return (
    <div className="saas-landing">
      <header className="hero-section">
        <div className="hero-content">
          <div className="badge-inovacao">🚀 A nova era da cobrança amigável</div>
          <h1 className="hero-title">
            Transforme dívidas perdidas em <span className="text-gradient">fluxo de caixa.</span>
          </h1>
          <p className="hero-subtitle">
            Plataforma inteligente de recuperação de ativos. Automatizamos a cobrança via WhatsApp, Email, PDF e PIX. 
            <strong> No plano FREE, você só paga se receber.</strong>
          </p>
          
          <div className="hero-actions">
            <button onClick={() => navigate('/registrar')} className="btn-primary-large">
              Começar a Recuperar
            </button>
            <button onClick={() => navigate('/login')} className="btn-secondary-large">
              Já sou parceiro
            </button>
          </div>
        </div>

        <div className="hero-visual">
          <div className="glass-card floating" style={{ minHeight: '170px', width: '100%', maxWidth: '350px', boxSizing: 'border-box' }}>
            <div className="glass-header">
              <div className="dot green"></div>
              <span>PIX Recebido</span>
            </div>
            
            <div 
              className={`glass-body ${fadeAtivo ? 'fade-out' : 'fade-in'}`} 
              style={{ 
                  minHeight: '80px', 
                  display: 'flex', 
                  flexDirection: 'column', 
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  width: '100%'
              }}
            >
              {notificacaoAtual && (
                <>
                  <span className="glass-value">
                    + R$ {notificacaoAtual.valor}
                  </span>
                  <span className="glass-desc">
                    {notificacaoAtual.descricao}
                  </span>
                </>
              )}
            </div>
          </div>
          <div className="glow-circle"></div>
        </div>
      </header>

      <section className="features-section">
        {loading ? (
          <p className="loading-text">Carregando planos...</p>
        ) : (
          planos.map((plano) => (
            <div key={plano.id} className="feature-card">
              <div className="feature-icon bg-green">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
              </div>
              <h3>{plano.nome}</h3>
              <div className="plan-price">
                R$ {plano.valorMensal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
              </div>
              <p className="plan-desc">
                Acomoda até <strong>{plano.limiteCredores} credores</strong> e <strong>{plano.limiteDevedoresPorCredor} devedores</strong>.
              </p>

              <button onClick={() => navigate('/registrar', { state: { planoId: plano.id, isFree: plano.valorMensal === 0 } })} className="btn-login-outline plan-btn">
                
                Assinar {plano.nome}
              </button>
            </div>
          ))
        )}
      </section>

      <footer className="landing-footer">
        <p>© 2026 QuitaGo. Tecnologia em recuperação de crédito.</p>
      </footer>
    </div>
  );
};

export default Home;